import { Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { SelectModule } from 'primeng/select';
import { CommunitySearchProvider } from '../../providers/community-search-provider';
import { GeolocatorEntity } from '@gishub/domain';

@Component({
  selector: 'app-community-search',
  standalone: true,
  imports: [FormsModule, SelectModule],
  template: `
    <div class="cs-wrapper">
      <p-select
        [options]="provider.state().results"
        optionLabel="name"
        [ngModel]="provider.state().selectedResult"
        (ngModelChange)="onSelect($event)"
        placeholder="Seleccionar comunidad..."
        [showClear]="true"
        [filter]="true"
        filterPlaceholder="Buscar comunidad..."
        styleClass="cs-select"
      >
        <ng-template let-item pTemplate="item">
          <div class="cs-option">
            <span class="cs-option-name">{{ item.name }}</span>
            <span class="cs-option-source">{{ item.sourceName === 'Comunidades campesinas' ? 'CC' : 'CN' }}</span>
          </div>
        </ng-template>
      </p-select>
    </div>
  `,
  styles: [`
    :host { display: block; }
    .cs-wrapper {
      font-family: var(--op-sans);
      font-size: clamp(0.75rem, 1.5dvh, 0.9rem);
      min-width: 16dvw;
    }
    :host ::ng-deep .cs-select {
      width: 100%;
      font-family: var(--op-sans);
    }
    :host ::ng-deep .cs-select .p-select-label {
      font-weight: 600;
    }
    :host ::ng-deep .cs-select .p-placeholder {
      font-weight: 500;
      color: var(--op-text-dim);
    }
    .cs-option {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 8px;
      width: 100%;
    }
    .cs-option-name {
      font-weight: 600;
      font-size: 0.82rem;
      color: var(--op-text-hi);
    }
    .cs-option-source {
      font-size: 0.6rem;
      font-weight: 700;
      padding: 1px 5px;
      border-radius: 3px;
      flex-shrink: 0;
      background: var(--op-bg-hover);
      color: var(--op-text-dim);
      letter-spacing: 0.04em;
    }
  `],
})
export class CommunitySearchComponent {
  protected readonly provider = inject(CommunitySearchProvider);

  onSelect(result: GeolocatorEntity | null): void {
    if (result) {
      this.provider.notifier.selectResult(result);
    } else {
      this.provider.notifier.clearSearch();
    }
  }
}
